import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { categories as getCategories } from '@/js/data/category';
import { materials } from '@/js/data/material';
import { colors } from '@/js/data/color';
import IButton from '@/js/components/molecules/IButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListingMenu',
  props: {
    initialQuery: null,
    initialCategory: null,
    initialSubCategory: null,
    initialFromPrice: null,
    initialToPrice: null,
    initialMaterial: null,
    initialColor: null,
    initialGift: null,
    initialOrdermade: null,
    initialVintage: null,
    initialSelling: null,
    sort: null,
    order: null
  },
  setup(__props: any) {

const props = __props as {
  initialQuery: string;
  initialCategory: string;
  initialSubCategory: string;
  initialFromPrice: string;
  initialToPrice: string;
  initialMaterial: string;
  initialColor: string;
  initialGift: string;
  initialOrdermade: string;
  initialVintage: string;
  initialSelling: string;
  sort: string;
  order: string;
};


const prices = ['500', '1000', '3000', '5000', '10000', '15000', '20000', '30000', '50000', '100000'];
const q = ref(props.initialQuery);
const fromPrice = ref(props.initialFromPrice);
const toPrice = ref(props.initialToPrice);
const category = ref(0);
const categories = ref<
  {
    categoryId: number;
    slug: string;
    name: string;
  }[]
>(getCategories({ parentCategoryId: 0 }));
const subCategory = ref(0);
const subCategories = ref<
  {
    categoryId: number;
    slug: string;
    name: string;
  }[]
>();
const material = ref(props.initialMaterial);
const color = ref(props.initialColor);
const gift = ref(props.initialGift === '1');
const ordermade = ref(props.initialOrdermade === '1');
const vintage = ref(props.initialVintage === '1');
const toggleSelling = ref(props.initialSelling === '1');
const categorySlug = computed(() => categories.value?.find((cat) => cat.categoryId === category.value)?.slug || '');
const subCategorySlug = computed(() => subCategories.value?.find((subCat) => subCat.categoryId === subCategory.value)?.slug || '');
const actionPath = computed(() => (categorySlug.value || subCategorySlug.value ? `/category${categorySlug.value ? `/${categorySlug.value}` : ''}${subCategorySlug.value ? `/${subCategorySlug.value}` : ''}` : '/listing'));
const selling = computed(() => (toggleSelling.value ? 'on' : 'off'));
const reset = () => {
  q.value = '';
  fromPrice.value = '';
  toPrice.value = '';
  material.value = '';
  color.value = '';
  category.value = 0;
  subCategory.value = 0;
  gift.value = false;
  vintage.value = false;
  ordermade.value = false;
  toggleSelling.value = false;
};
const onChangeCategory = () => {
  subCategories.value = getCategories({ parentCategoryId: category.value });
  subCategory.value = 0;
};
const onSubmit = () => {
  if (q.value) {
    window.dataLayer?.push({
      event: 'search',
      search_term: q.value,
    });
  }
};

onMounted(() => {
  const initialCategory = categories.value?.find((cat) => cat.name === props.initialCategory);
  if (initialCategory) {
    category.value = initialCategory.categoryId;
    onChangeCategory();
  }
  const initialSubCategory = subCategories.value?.find((cat) => cat.name === props.initialSubCategory);
  if (initialSubCategory) {
    subCategory.value = initialSubCategory.categoryId;
  }
});

return { __sfc: true,props, prices, q, fromPrice, toPrice, category, categories, subCategory, subCategories, material, color, gift, ordermade, vintage, toggleSelling, categorySlug, subCategorySlug, actionPath, selling, reset, onChangeCategory, onSubmit, materials, colors, IButton }
}

})